var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStorage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3469 9.10547L9.90296 9.93396L9.59909 9.6301L9.16406 10.0651L10.0539 10.955L10.8892 9.396L10.3469 9.10547Z",
    fill: "#023E8A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.3371 3.60384L6.99961 1.6814L1.66211 3.60383V10.3525L6.99963 12.2749L8.5052 11.7325C8.91207 12.0934 9.44735 12.3131 10.033 12.3131C11.2808 12.3131 12.3 11.3166 12.3368 10.0775L12.3371 3.60384ZM5.77312 2.96309L6.99961 2.52133L10.7785 3.8824L9.55343 4.32583L5.77312 2.96309ZM6.99961 5.25022L3.22069 3.8824L4.6075 3.38291L8.3907 4.7467L6.99961 5.25022ZM2.45234 9.7972V4.4447L6.60449 5.9476V11.2927L2.45234 9.7972ZM7.39473 11.2926V5.9476L11.5469 4.4447V8.2716C11.1417 7.91798 10.612 7.70334 10.033 7.70334C8.76198 7.70334 7.72809 8.73723 7.72809 10.0082C7.72809 10.3939 7.82343 10.7578 7.99163 11.0776L7.39473 11.2926ZM8.51833 10.0082C8.51833 9.17313 9.19787 8.49357 10.033 8.49357C10.8583 8.49357 11.5312 9.15738 11.5469 9.97906V10.0374C11.5312 10.8591 10.8583 11.5229 10.033 11.5229C9.19787 11.5229 8.51833 10.8434 8.51833 10.0082Z",
    fill: "#023E8A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStorage);
export default __webpack_public_path__ + "static/media/Storage.5426020d2de95e52b3be8fecbe097714.svg";
export { ForwardRef as ReactComponent };